<template>
  <div>
    <div
      v-show="!noResult"
      class="text-left mb-4"
    >
      <span
        v-html="
          $i18nPresenter.t('filteredPresentationsTotalResult', {
            length: filteredPresentations.length,
            text: searchText
          })
        "
      >
      </span>
    </div>
    <div
      class="templates"
      v-show="!isLoadingTemplates"
      v-if="filteredPresentations && filteredPresentations.length > 0"
    >
      <div class="templates-container">
        <TemplateCard
          class="mb-6"
          v-for="presentation in filteredPresentations"
          :key="presentation.id"
          :presentation="presentation"
        />
      </div>

      <div v-if="isLoadmore" class="w-full mb-4 text-center">
        <aha-button
          @click="loadMore()"
          :submitting="isLoadingMore"
          :disabled="isLoadingMore"
        >
          {{ $i18nPresenter.t("Load more...") }}
        </aha-button>
      </div>
    </div>
    <TemplateSearchNoData
      v-show="!isLoadingTemplates"
      v-if="noResult && isSearching"
      :keyword="searchText"
      @request="clearSearch()"
    />
  </div>
</template>
<script>
// This component is DEPRECATED.
//
// **Related Issue:**
// Organizing Template Library by Primary Use Cases
// (https://ahaslides.atlassian.net/browse/AHA-28934) (Feature: F)
//
// **Feature Flag:**
// release-reorganising-template-library
//
// **Removal Conditions:**
// - The feature (F) is 100% live.
// - The feature flag is fully enabled.
// - The EU environment is no longer frozen
//   (details: https://ahaslides.atlassian.net/browse/AHA-30247).
//
// **Replacement:**
// Use "@/components-v2/template-library/v2/template-container/SearchResultSection.vue" instead.
//
// TODO: Remove this file once all the above conditions are met.

import { mapGetters } from 'vuex'
import TemplateCard from './TemplateCard.vue'
import TemplateSearchNoData from '@/components-v2/common/template-library/TemplateSearchNodataMergeSearch.vue'

export default {
  components: {
    TemplateCard,
    TemplateSearchNoData,
  },
  props: {
    filteredPresentations: {
      type: Array,
      default: () => [],
    },
    noResult: {
      type: Boolean,
      default: false,
    },
    isSearching: {
      type: Boolean,
      default: false,
    },
    searchText: {
      type: String,
      default: '',
    },
    isLoadmore: {
      type: Boolean,
      default: false,
    },
    isLoadingMore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters('presentationTemplates', [
      'isLoadingTemplates',
    ]),
  },
  methods: {
    loadMore() {
      this.$emit('loadMore')
    },
  },
}
</script>
<style scoped lang='scss'>

</style>
